var cilCrop = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M433.372,56H88V16H56V56H16V88H56V456H424v40h32V456h40V424H456V78.628l40-40V16H473.372Zm-32,32L88,401.372V88ZM424,424H110.628L424,110.628Z' class='ci-primary'/>"];

export { cilCrop };
